import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { RESTDataSource } from "@apollo/datasource-rest";
import config from "@/lib/config";
import { v4 as uuidv4 } from "uuid";

var PinManager = /*#__PURE__*/function (_RESTDataSource) {
  _inherits(PinManager, _RESTDataSource);

  var _super = _createSuper(PinManager);

  function PinManager(options) {
    var _this;

    _classCallCheck(this, PinManager);

    _this = _super.call(this, options);

    _defineProperty(_assertThisInitialized(_this), "baseURL", config.api.vcmsURL);

    _this.context = options;
    return _this;
  }

  _createClass(PinManager, [{
    key: "willSendRequest",
    value: function willSendRequest(_path, request) {
      var _this$context$req;

      if ((_this$context$req = this.context.req) !== null && _this$context$req !== void 0 && _this$context$req.userToken) {
        var _this$context$req$use = this.context.req.userToken,
            id = _this$context$req$use.id,
            accessToken = _this$context$req$use.accessToken;
        request.headers["X-Token-Id"] = id;
        request.headers["Authorization"] = "Bearer ".concat(accessToken);
      }

      var requestId = uuidv4();
      request.headers["X-Spoox-Web-Session-Request-Id"] = requestId;
      var userId = request.headers["X-User-Id"];
      console.log("[".concat(requestId, "][Session][REQUEST INFO] Method: ").concat(request.method, ", Path: ").concat(_path, ", UserId: ").concat(userId));
    }
  }, {
    key: "didReceiveResponse",
    value: function () {
      var _didReceiveResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, request) {
        var requestId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestId = request.headers["X-Spoox-Web-Session-Request-Id"];
                console.log("[".concat(requestId, "][Session][RESPONSE INFO] Status: ").concat(response.status));
                return _context.abrupt("return", _get(_getPrototypeOf(PinManager.prototype), "didReceiveResponse", this).call(this, response, request));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function didReceiveResponse(_x, _x2) {
        return _didReceiveResponse.apply(this, arguments);
      }

      return didReceiveResponse;
    }()
  }, {
    key: "pinActivate",
    value: function () {
      var _pinActivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(code) {
        var params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // TVデバイスのアクティベーションコードの認証
                params = {
                  pin_code: code
                };
                return _context2.abrupt("return", this.post("/pin/activate", {
                  body: params
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function pinActivate(_x3) {
        return _pinActivate.apply(this, arguments);
      }

      return pinActivate;
    }()
  }]);

  return PinManager;
}(RESTDataSource);

export default PinManager;